import { get, post } from './request'
import { utilities } from '@billow/js-helpers'

export let paginate = (path, success, failure) => {
  return get(
    `api${path}`, success, failure
  )
}

export let load = (gallery, success, failure) => get(
  `api/cms/gallery/${gallery}`, success, failure
)

export let list = (success, failure) => get(
  `api/cms/galleries/all`, success, failure
)

export let create = (gallery, success, failure) => post(
  `api/cms/gallery/create`, gallery, success, failure
)

export let save = (gallery, success, failure) => post(
  `api/cms/gallery/${gallery.id}/update`, gallery, success, failure
)

export let remove = (gallery, success, failure) => post(
  `api/cms/gallery/${gallery}/remove`, {}, success, failure
)

export let saveFile = (payload, success, failure) => {
  return post(
    `api/cms/gallery/${payload.galleryId}/file`,
    utilities.formData(payload),
    success,
    failure
  )
}

export let removeFile = (image, success, failure) => post(
  `api/cms/gallery/file/${image}/remove`, {}, success, failure
)

export let loadGalleryImage = (imageId, success, failure) => get(
  `api/cms/gallery/file/${imageId}`, success, failure
)
  
export let updateGalleryImage = (payload, success, failure) => post(
  `api/cms/gallery/file/${payload.id}/update`, payload, success, failure
)